import React, { useEffect, useRef, useState } from 'react';
import Icon from './Icon';
import { links } from '../siteData';
import { ExternalLink } from './Shared';
import './Header.css';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [arcadeOpen, setArcadeOpen] = useState(false);
  const headerRef = useRef(null);
  const toggleRef = useRef(null);
  const arcadeRef = useRef(null);
  const closeMenus = () => { setOpen(false); setArcadeOpen(false); };

  useEffect(() => {
    const closeOutside = event => {
      if (!headerRef.current?.contains(event.target)) { setOpen(false); setArcadeOpen(false); }
    };
    const escape = event => {
      if (event.key !== 'Escape') return;
      if (arcadeOpen) { setArcadeOpen(false); arcadeRef.current?.focus(); }
      else if (open) { setOpen(false); toggleRef.current?.focus(); }
    };
    const media = window.matchMedia('(min-width: 1024px)');
    const resize = () => { setArcadeOpen(false); if (media.matches) setOpen(false); };
    document.addEventListener('pointerdown', closeOutside);
    document.addEventListener('keydown', escape);
    media.addEventListener('change', resize);
    return () => {
      document.removeEventListener('pointerdown', closeOutside);
      document.removeEventListener('keydown', escape);
      media.removeEventListener('change', resize);
    };
  }, [open, arcadeOpen]);

  return <header className="site-header" ref={headerRef} onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) closeMenus();
  }}>
    <div className="container header-inner">
      <a className="wordmark" href="#home" onClick={closeMenus}>ULTRA <span>$MAGA</span><span className="brand-star" aria-hidden="true">★</span></a>
      <button className="menu-toggle" ref={toggleRef} aria-label={open ? 'Close navigation' : 'Open navigation'} aria-expanded={open} aria-controls="main-navigation" onClick={() => { setOpen(!open); setArcadeOpen(false); }}><Icon name={open ? 'close' : 'menu'} /></button>
      <nav id="main-navigation" className={`main-nav ${open ? 'is-open' : ''}`} aria-label="Main navigation">
        {[['#home','Home'],['#ecosystem','Ecosystem'],['#about','About'],['#tokenomics','Tokenomics'],['#buy','How to buy'],['#roadmap','Roadmap']].map(([href,label]) => <a key={href} href={href} onClick={closeMenus}>{label}</a>)}
        <div className="arcade-picker" onBlur={event => {
          if (!event.currentTarget.contains(event.relatedTarget)) setArcadeOpen(false);
        }}>
          <button ref={arcadeRef} className="arcade-toggle" aria-expanded={arcadeOpen} aria-controls="arcade-games" onClick={() => setArcadeOpen(!arcadeOpen)}>
            Arcade <svg className="arcade-chevron" width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="m3 4.5 3 3 3-3" fill="none" stroke="currentColor" strokeWidth="1.5" /></svg>
          </button>
          <div id="arcade-games" className="arcade-games" hidden={!arcadeOpen}>
            <p className="arcade-picker-label">Choose your game</p>
            <a href={links.game} onClick={closeMenus}>
              <span className="arcade-game-art"><img src="/flappytrump/assets/trump.png" alt="" /></span>
              <span><strong>Flappy Trump</strong><small>Fly through the obstacles</small></span>
              <Icon name="arrow" />
            </a>
            <a href={links.arcade} onClick={closeMenus}>
              <span className="arcade-game-art swamp-thumbnail"><img src="/games/crossing-the-swamp/assets/swamp.png" alt="" /></span>
              <span><strong>Crossing the Swamp</strong><small>Hop your way to safety</small></span>
              <Icon name="arrow" />
            </a>
          </div>
        </div>
        <ExternalLink href={links.nft} className="mobile-nft" onClick={closeMenus}>NFT collection <Icon name="external" /></ExternalLink>
        <ExternalLink className="button button-small button-primary" href={links.firstLedger}>Buy $MAGA <Icon name="arrow" /></ExternalLink>
      </nav>
    </div>
  </header>;
}
